<template>
  <v-main>
    <v-container fluid>
      <v-toolbar class="elevation-0">
        <v-toolbar-title class="pl-0">Gerar Financeiro</v-toolbar-title>
      </v-toolbar>
      <div class="row align-center" style="max-width: 900px; margin: 20px auto">
        <div class="col">
          <v-text-field
            label="ID da Fatura"
            v-model="invoiceId"
            type="text"
            outlined dense hide-details
          ></v-text-field>
        </div>
        <div class="col">
          <v-text-field
            label="ID da conta"
            v-model="accountId"
            type="text"
            outlined dense hide-details
          ></v-text-field>
        </div>
        <div class="col">
          <v-text-field
            label="ID do operacao"
            v-model="operactionID"
            type="text"
            outlined dense hide-details
          ></v-text-field>
        </div>
        <div class="col-auto">
          <v-btn color="primary" :disabled="!invoiceId" @click="getData">
            Gerar
          </v-btn>
        </div>
      </div>
      <template v-if="invoiceData">
        <v-divider />
        <div class="row py-md">
          <div v-for="(financial, index) in generatedFinancial" :key="index" class="col pa-5 ma-3 grey lighten-2">
            <div class="text-right">
              <v-btn @click="copyFinancial(financial)" color="primary" fab text small dark>
                <v-icon>mdi-code-tags</v-icon>
              </v-btn>
            </div>
            <pre>{{ financial }}</pre>
          </div>
        </div>
      </template>
    </v-container>
  </v-main>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import axios from 'axios'

export default {
  name: 'generateFinancial',
  data: () => ({
    loading: false,
    invoiceId: '',
    accountId: '',
    operactionID: '',
    invoiceData: null
  }),
  computed: {
    totalValue () {
      let totalValue = 0
      if (this.invoiceData && this.invoiceData.items) {
        for (const item of this.invoiceData.items) {
          totalValue += item.amount
        }
      }
      return totalValue
    },
    feeApplied () {
      return this.invoiceData && this.invoiceData.fee_applied && this.invoiceData.fee_applied.fee
    },
    taxAmount () {
      const totalPaid = this.gatewayResponse.transaction && this.gatewayResponse.transaction.total_paid_amount || 0
      if (totalPaid) return parseFloat((parseFloat(totalPaid) - this.totalValue).toFixed(2))
      return 0
    },
    gatewayResponse () {
      let gatewayResponse = null
      if (this.invoiceData && this.invoiceData.gateway_responses) {
        gatewayResponse = this.invoiceData.gateway_responses.find(e => parseInt(e.id) === parseInt(this.operactionID))
      }
      return gatewayResponse
    },
    generatedFinancial () {
      const customer = { ...this.invoiceData.customer, address: { ...this.invoiceData.customer.address } }
      delete customer.address.created_at
      delete customer.address.updated_at
      delete customer.address.id
      customer.created_at = { $date: this.$moment(customer.created_at, 'YYYY-MM-DD HH:mm:ss').add(3, 'hours').format('YYYY-MM-DDTHH:mm:ss[.000Z]') }
      customer.updated_at = { $date: this.$moment(customer.updated_at, 'YYYY-MM-DD HH:mm:ss').add(3, 'hours').format('YYYY-MM-DDTHH:mm:ss[.000Z]') }

      const celebration = { name: this.invoiceData.account.name }

      const invoice = {
        heppi: this.invoiceId,
        gateway: {
          $numberLong: this.operactionID // aquiiiiiiiiiiiii
        }
      }

      const financialDate = { $date: this.$moment(this.invoiceData.invoice_date, 'YYYY-MM-DD HH:mm:ss').add(3, 'hours').format('YYYY-MM-DDTHH:mm:ss[.000Z]') }
      const dueDate = { $date: this.$moment(this.invoiceData.due_date, 'YYYY-MM-DD HH:mm:ss').add(3, 'hours').format('YYYY-MM-DDTHH:mm:ss[.000Z]') }
      const paymentDate = { $date: this.$moment(this.invoiceData.payment_date, 'YYYY-MM-DD HH:mm:ss').add(3, 'hours').format('YYYY-MM-DDTHH:mm:ss[.000Z]') }
      const createdAt = { $date: this.$moment(this.invoiceData.created_at, 'YYYY-MM-DD HH:mm:ss').add(3, 'hours').format('YYYY-MM-DDTHH:mm:ss[.000Z]') }
      const updatedAt = { $date: this.$moment(this.invoiceData.updated_at, 'YYYY-MM-DD HH:mm:ss').add(3, 'hours').format('YYYY-MM-DDTHH:mm:ss[.000Z]') }
      const moneyReleaseDate = { $date: this.$moment(this.invoiceData.payment_date, 'YYYY-MM-DD HH:mm:ss').add(3, 'hours').add(2, 'd').format('YYYY-MM-DDTHH:mm:ss[.000Z]') }

      const financials = []

      // financial referente aos items
      for (const item of this.invoiceData.items) {
        financials.push({
          account_id: this.accountId,
          customer,
          invoice,
          celebration,
          amount: item.amount * item.quantity, // aquiiiiiiiiiiiii
          financial_date: financialDate,
          due_date: dueDate,
          payment_date: paymentDate,
          installment: this.invoiceData.installments,
          category: item.category, // aquiiiiiiiiiiiii
          payment_method: this.invoiceData.payment_method,
          financial_type: (item.category === 'discount') ? 'debit' : 'credit', // aquiiiiiiiiiiiii
          processor: 'mercado-pago',
          product: this.invoiceData.product_reference,
          created_at: createdAt,
          updated_at: updatedAt,
          money_release_date: moneyReleaseDate,
          description: item.description // aquiiiiiiiiiiiii
        })
      }

      // financial referente a taxa heppi
      if (this.feeApplied.processing_mode === 'increment') {
        financials.push({
          account_id: this.accountId,
          customer,
          invoice,
          celebration,
          amount: this.taxAmount, // aquiiiiiiiiiiiii
          financial_date: financialDate,
          due_date: dueDate,
          payment_date: paymentDate,
          installment: this.invoiceData.installments,
          category: 'heppi_fee', // aquiiiiiiiiiiiii
          payment_method: this.invoiceData.payment_method,
          financial_type: 'credit', // aquiiiiiiiiiiiii
          processor: 'mercado-pago',
          product: this.invoiceData.product_reference,
          created_at: createdAt,
          updated_at: updatedAt,
          money_release_date: moneyReleaseDate,
          description: 'Taxa Heppi' // aquiiiiiiiiiiiii
        })
      }
      financials.push({
        account_id: this.accountId,
        customer,
        invoice,
        celebration,
        amount: this.taxAmount, // aquiiiiiiiiiiiii
        financial_date: financialDate,
        due_date: dueDate,
        payment_date: paymentDate,
        installment: this.invoiceData.installments,
        category: 'heppi_fee', // aquiiiiiiiiiiiii
        payment_method: this.invoiceData.payment_method,
        financial_type: 'debit', // aquiiiiiiiiiiiii
        processor: 'mercado-pago',
        product: this.invoiceData.product_reference,
        created_at: createdAt,
        updated_at: updatedAt,
        money_release_date: moneyReleaseDate,
        description: 'Taxa Heppi' // aquiiiiiiiiiiiii
      })
      financials.push({
        account_id: '5dee9df01b959a0ca106e2a2',
        customer,
        invoice,
        celebration,
        amount: this.taxAmount, // aquiiiiiiiiiiiii
        financial_date: financialDate,
        due_date: dueDate,
        payment_date: paymentDate,
        installment: this.invoiceData.installments,
        category: 'heppi_fee', // aquiiiiiiiiiiiii
        payment_method: this.invoiceData.payment_method,
        financial_type: 'credit', // aquiiiiiiiiiiiii
        processor: 'mercado-pago',
        product: this.invoiceData.product_reference,
        created_at: createdAt,
        updated_at: updatedAt,
        money_release_date: moneyReleaseDate,
        description: 'Taxa Heppi' // aquiiiiiiiiiiiii
      })

      for (const fee of this.gatewayResponse.fees) {
        financials.push({
          account_id: '5dee9df01b959a0ca106e2a2',
          customer,
          invoice,
          celebration,
          amount: fee.amount, // aquiiiiiiiiiiiii
          financial_date: financialDate,
          due_date: dueDate,
          payment_date: paymentDate,
          installment: this.invoiceData.installments,
          category: fee.type === 'financing_fee' ? 'advance_fee' : 'gateway_fee', // aquiiiiiiiiiiiii
          payment_method: this.invoiceData.payment_method,
          financial_type: 'debit', // aquiiiiiiiiiiiii
          processor: 'mercado-pago',
          product: this.invoiceData.product_reference,
          created_at: createdAt,
          updated_at: updatedAt,
          money_release_date: moneyReleaseDate,
          description: fee.type === 'financing_fee' ? 'Taxa de Antecipação' : 'Taxa Gateway' // aquiiiiiiiiiiiii
        })
      }

      return financials
    }
  },
  methods: {
    ...mapMutations(['SET_SNACKBAR']),
    ...mapActions(['copyToClipboard']),
    getData () {
      let vue = this
      vue.loading = true

      axios.get('invoices/' + vue.invoiceId, { baseURL: 'https://payment-gateway-api.heppi.io/api/' })
        .then(response => {
          if (response.data) {
            vue.loading = false
            vue.invoiceData = response.data
          } else {
            vue.loading = false
            vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
            vue.invoiceData = null
          }
        })
        .catch(() => {
          vue.loading = false
          vue.SET_SNACKBAR({ text: 'Houve um erro ao processar seu pedido. Tente novamente.' })
          vue.invoiceData = null
        })
    },
    copyFinancial (financial) {
      let financialString = JSON.stringify(financial)
      financialString = financialString.substring(1, financialString.length - 1)
      this.copyToClipboard(financialString)
    }
  }
}
</script>
